// RUSSIAN (ru) for the console's support, staff and audit screens and the
// S19 banner (M15-8, M15-9). Same keys as admin-ops.i18n.ts; the terms follow
// admin.ru.ts (клиент for tenant, песочница for sandbox).

import type { Translated } from "../../i18n-shape.js";
import type { adminOpsEn } from "./admin-ops.i18n.js";

export const adminOpsRu: Translated<typeof adminOpsEn> = {
  support: {
    tabOverview: "Обзор",
    tabSupport: "Поддержка",
    tabsLabel: "Разделы клиента",
    title: "Поддержка",
    lead: "Помогите сотрудникам клиента: откройте клиента от имени одного из них, отправьте ссылку для сброса пароля или завершите его сеансы.",
    viewerNote:
      "Этими инструментами пользуются поддержка и администраторы платформы. История доступа ниже доступна вам для чтения.",
    seeAudit: "Журнал аудита этого клиента",
    people: "Сотрудники",
    search: "Поиск",
    searchPlaceholder: "Имя или email",
    loading: "Загрузка сотрудников…",
    empty: "У этого клиента никто не подходит под запрос.",
    emptyAll: "У этого клиента пока нет сотрудников.",
    loadFailed: "Не удалось загрузить сотрудников клиента.",
    colName: "Имя",
    colEmail: "Эл. почта",
    colRoles: "Роли",
    colLastLogin: "Последний вход",
    never: "Никогда",
    locked: "Заблокирован",
    actionsFor: "Действия для {{name}}",
    impersonate: "Открыть от имени сотрудника",
    sendReset: "Отправить сброс пароля",
    revokeSessions: "Завершить все сеансы",
    resetSent: "Ссылка для сброса пароля отправлена на {{email}}.",
    resetNotEligible: {
      email_unverified:
        "{{email}} ещё не подтвердил адрес электронной почты, поэтому ссылку для сброса отправить нельзя.",
      user_not_active:
        "Учётная запись этого сотрудника неактивна, поэтому ссылку для сброса отправить нельзя.",
      not_a_person: "Эта учётная запись не принадлежит человеку, поэтому пароля у неё нет.",
    },
    revoked: "{{name}} вышел из этого клиента. Завершено сеансов: {{count}}",
    revokeTitle: "Завершить все сеансы {{name}}?",
    revokeBody:
      "Каждый сеанс {{name}} у этого клиента завершится при следующем запросе. Войти снова можно.",
    revokeConfirm: "Завершить сеансы",
    cancel: "Отмена",
    close: "Закрыть",
    grantTitle: "Открыть клиента от имени {{name}}",
    mode: "Доступ",
    modes: {
      read_only: "Только чтение",
      act_as: "Действовать от имени сотрудника",
    },
    modeHelp: {
      read_only: "Вы видите то же, что и сотрудник. Любое изменение будет отклонено.",
      act_as:
        "Вы можете вносить изменения от имени сотрудника. Каждое изменение записывается под вашим именем.",
    },
    approvalNote:
      "Чтобы действовать от чужого имени, нужно одобрение администратора платформы до открытия клиента.",
    reason: "Причина",
    reasonHint: "Не меньше 10 символов. Сохраняется вместе с записью о доступе.",
    ticket: "Заявка",
    ticketPlaceholder: "например, SUP-341",
    duration: "Срок",
    durationOption: "{{minutes}} мин",
    request: "Запросить доступ",
    requesting: "Запрос…",
    pending: "Ожидает одобрения администратора платформы.",
    granted: "Доступ выдан. Откройте клиента, когда будете готовы.",
    open: "Открыть клиента",
    opening: "Открываем…",
    openNote: "Клиент откроется в новой вкладке. Ссылка работает один раз в течение двух минут.",
    liveTitle: "Действующий доступ",
    liveEmpty: "Сейчас ни у кого из Assessly нет доступа к этому клиенту.",
    historyTitle: "История доступа поддержки",
    historyEmpty: "Никто из Assessly ещё не открывал этого клиента.",
    historyMore: "Показать раньше",
    historyFailed: "Не удалось загрузить историю доступа.",
    colStaff: "Сотрудник платформы",
    colPerson: "Сотрудник клиента",
    colMode: "Доступ",
    colTicket: "Заявка",
    colStatus: "Статус",
    colStarted: "Начало",
    colLeft: "Осталось",
    colChanges: "Внесено изменений",
    minutesLeft: "{{minutes}} мин",
    grantStatus: {
      pending_approval: "Ожидает одобрения",
      active: "Действует",
      ended: "Завершён",
      expired: "Истёк",
      revoked: "Отозван",
    },
    approve: "Одобрить",
    approving: "Одобряем…",
    end: "Завершить",
    ending: "Завершаем…",
    unknownPerson: "Больше не у клиента",
    dangerTitle: "Инцидент безопасности",
    dangerBody:
      "Сразу завершает все сеансы у этого клиента и отзывает весь действующий доступ сотрудников Assessly.",
    revokeAll: "Завершить сеансы всех",
    revokeAllTitle: "Завершить сеансы всех у клиента {{tenant}}?",
    revokeAllBody:
      "Каждый сеанс у этого клиента завершится при следующем запросе, а весь действующий доступ сотрудников Assessly будет отозван. Войти снова можно.",
    revokeAllConfirmLabel: "Введите {{subdomain}} для подтверждения",
    revokeAllDone:
      "Сеансы всех завершены. Завершено сеансов: {{sessions}}. Отозвано доступов: {{grants}}.",
    failure: {
      session: "Сессия истекла. Войдите заново, чтобы продолжить.",
      scope: "Сотрудники песочницы могут просматривать этого клиента, но не изменять его.",
      role: "Вашей роли это недоступно.",
      last_admin:
        "Это последний активный администратор платформы. Сначала назначьте администратором кого-то ещё.",
      self: "Здесь нельзя менять собственную учётную запись.",
      state: "Кто-то изменил это раньше. Список загружен заново.",
      not_eligible: "Этому сотруднику нельзя отправить ссылку для сброса.",
      confirmation: "Это не поддомен этого клиента.",
      already_accepted: "Приглашение уже принято.",
      grant_live: "У вас уже есть действующий доступ к этому клиенту. Сначала завершите его.",
      not_found: "Этого сотрудника или записи здесь больше нет.",
      failed: "Не получилось. Попробуйте ещё раз.",
    },
  },
  banner: {
    viewing: "{{name}} из поддержки Assessly работает в этой учётной записи",
    viewingUnnamed: "Поддержка Assessly работает в этой учётной записи",
    ticket: "Заявка {{ticket}}",
    mode: {
      read_only: "Только чтение",
      act_as: "Может вносить изменения",
    },
    left: "Осталось {{minutes}} мин",
    end: "Завершить сеанс",
    ending: "Завершаем…",
    endFailed: "Не удалось завершить сеанс. Попробуйте ещё раз.",
    landingTitle: "Открываем сеанс поддержки…",
    landingFailedTitle: "Эту ссылку поддержки нельзя использовать",
    landingFailedBody:
      "Ссылка поддержки работает один раз, две минуты и только у своего клиента. Откройте клиента заново из консоли.",
    landingMissing: "Для этой страницы нужна ссылка из консоли.",
    endedTitle: "Сеанс поддержки завершён",
    endedBody: "Этот браузер вышел из клиента.",
    goSignIn: "Перейти ко входу",
  },
  staffAdmin: {
    title: "Сотрудники платформы",
    lead: "Все, кто может входить в эту консоль.",
    loading: "Загрузка сотрудников…",
    loadFailed: "Не удалось загрузить список сотрудников.",
    readOnlyNote: "Менять сотрудников может только администратор платформы.",
    forbiddenTitle: "Вашей роли список сотрудников недоступен",
    forbiddenBody: "Он доступен администраторам платформы и сотрудникам с правом только чтения.",
    invite: "Пригласить",
    inviteTitle: "Пригласить сотрудника",
    email: "Эл. почта",
    name: "Имя",
    role: "Роль",
    scope: "Охват",
    scopes: {
      fleet: "Все клиенты",
      sandbox: "Только клиенты песочницы",
    },
    inviteSend: "Отправить приглашение",
    inviting: "Отправляем…",
    invited: "Приглашение отправлено на {{email}}.",
    colName: "Имя",
    colRole: "Роль",
    colStatus: "Статус",
    colTwoFactor: "Двухфакторная аутентификация",
    colLastLogin: "Последний вход",
    never: "Никогда",
    you: "Вы",
    sandbox: "Песочница",
    status: {
      invited: "Приглашён",
      totp_pending: "Настраивает двухфакторную аутентификацию",
      active: "Активен",
      disabled: "Отключён",
    },
    twoFactorOn: "Включена",
    twoFactorOff: "Не настроена",
    actionsFor: "Действия для {{name}}",
    changeRole: "Изменить роль",
    disable: "Отключить",
    enable: "Включить снова",
    resendInvite: "Отправить приглашение снова",
    resetTotp: "Сбросить двухфакторную аутентификацию",
    roleTitle: "Изменить роль: {{name}}",
    roleSave: "Сохранить роль",
    disableTitle: "Отключить {{name}}?",
    disableBody:
      "Все сеансы сразу завершатся, а доступ к клиентам будет отозван. При повторном включении сотрудник получит новое приглашение.",
    enableTitle: "Включить {{name}} снова?",
    enableBody:
      "Мы отправим новое приглашение. Перед входом сотрудник задаст новый пароль и двухфакторную аутентификацию.",
    resetTitle: "Сбросить двухфакторную аутентификацию: {{name}}",
    resetBody:
      "Сеансы сразу завершатся, а при следующем входе сотрудник настроит двухфакторную аутентификацию заново. Используйте это, если он потерял телефон и коды восстановления.",
    resetReason: "Причина",
    resetReasonHint: "Не меньше 5 символов, например номер заявки.",
    resetConfirmLabel: "Введите {{email}} для подтверждения",
    working: "Сохраняем…",
    roleChanged: "Новая роль {{name}}: {{role}}",
    disabled: "{{name}} отключён.",
    enabled: "Сотрудник {{name}} снова включён. Новое приглашение отправлено на {{email}}.",
    resent: "Новое приглашение отправлено на {{email}}.",
    reset: "{{name}} настроит двухфакторную аутентификацию при следующем входе.",
    exists: "Сотрудник с таким email уже есть.",
    sandboxNotAllowed: "Сотрудников песочницы здесь пригласить нельзя.",
    lowCodesTitle: "Осталось кодов восстановления: {{count}}",
    lowCodesBody: "Создайте новый набор сейчас, пока приложение-аутентификатор у вас.",
    lowCodesAction: "Создать новые коды",
  },
  audit: {
    title: "Журнал аудита",
    lead: "Все изменения, сделанные из этой консоли, по порядку. Записи нельзя изменить.",
    loading: "Загрузка журнала аудита…",
    loadFailed: "Не удалось загрузить журнал аудита.",
    forbiddenTitle: "Вашей роли журнал аудита недоступен",
    forbiddenBody: "Он доступен администраторам платформы и сотрудникам с правом только чтения.",
    empty: "Под эти фильтры ничего не подходит.",
    emptyAll: "Пока ничего не записано.",
    staff: "Сотрудник платформы",
    anyStaff: "Любой",
    action: "Действие начинается с",
    actionPlaceholder: "например, staff. или tenant.",
    actionInvalid: "Используйте строчные латинские буквы, цифры, точки и подчёркивания.",
    from: "С",
    to: "По",
    clear: "Сбросить фильтры",
    tenantFilter: "Клиент: {{name}}",
    removeTenant: "Убрать фильтр по клиенту",
    export: "Выгрузить NDJSON",
    exporting: "Выгружаем…",
    exportFailed: "Не удалось выгрузить журнал аудита.",
    colWhen: "Когда",
    colWho: "Кто",
    colAction: "Действие",
    colTenant: "Клиент",
    filterTenant: "Только этот клиент",
    entry: "Запись №{{id}}",
    details: "Подробности записи №{{id}}",
    before: "До",
    after: "После",
    metadata: "Подробности",
    nothing: "Ничего не записано",
    automatic: "Автоматически",
    platformStaff: "Сотрудник платформы",
    noTenant: "Платформа",
    more: "Показать раньше",
    chainTitle: "Проверка цепочки",
    verdict: {
      intact: "Цела",
      broken: "Нарушена",
      never_verified: "Не проверялась",
    },
    neverVerified: "Цепочка ещё не проверялась.",
    intact: "Цела до записи №{{id}}. Проверено {{when}}.",
    broken: "Нарушена на записи №{{id}}: {{reason}}. Проверено {{when}}.",
    breakReason: {
      id_gap: "пропущена запись",
      prev_hash_mismatch: "запись больше не связана с предыдущей",
      curr_hash_mismatch: "запись изменена после того, как была сделана",
    },
    anchored: "Закреплено {{when}}.",
    notAnchored: {
      no_anchor_store: "Хранилище для закрепления не настроено, поэтому вершина не закреплена.",
      chain_broken: "Нарушенная цепочка никогда не закрепляется.",
      put_failed: "Хранилище для закрепления не ответило. Следующая проверка попробует снова.",
    },
    verifyNow: "Проверить сейчас",
    verifying: "Проверяем…",
    verifyFailed: "Проверка не выполнилась. Попробуйте ещё раз.",
  },
  opsNav: {
    staff: "Сотрудники",
    audit: "Журнал аудита",
  },
};
